import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import JobSearchPage from './pages/jobsSearchPage';
import Login from './pages/Login';
import Signup from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminPanel from './pages/AdminPanel';
import TeamLeadHome from './pages/TeamLeadHome';
import RecruiterHome from './pages/RecruiterHome';
import ProtectedRoute from './components/ProtectedRoute';
import { Route, Routes } from 'react-router-dom';
import SavedJobsView from './pages/SavedJobsView';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path='/' element={<Login/>}></Route>
        <Route path='/signup' element={<Signup/>}></Route>
        <Route path='/verify-email/:token' element={<VerifyEmail/>}></Route>
        <Route path='/forgot-password' element={<ForgotPassword/>}></Route>
        <Route path='/reset-password/:token' element={<ResetPassword/>}></Route>

        <Route
          path='/admin'
          element={
            <ProtectedRoute allowedRoles={['ADMIN']}>
              <AdminPanel/>
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path='/team-lead/home'
          element={
            <ProtectedRoute allowedRoles={['TEAM_LEAD']}>
              <TeamLeadHome/>
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path='/team-lead/jobs-search'
          element={
            <ProtectedRoute allowedRoles={['TEAM_LEAD']}>
              <JobSearchPage/>
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path='/team-lead/saved-jobs'
          element={
            <ProtectedRoute allowedRoles={['TEAM_LEAD']}>
              <SavedJobsView/>
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path='/recruiter/home'
          element={
            <ProtectedRoute allowedRoles={['RECRUITER']}>
              <RecruiterHome/>
            </ProtectedRoute>
          }
        ></Route>

        <Route
  path='/recruiter/jobs'
  element={
    <ProtectedRoute allowedRoles={['RECRUITER']}>
      <SavedJobsView/>
    </ProtectedRoute>
  }
></Route>
      </Routes>
    </ThemeProvider>
  );
}